import React from 'react'
import { useTranslation } from 'contexts/Localization'
import useTheme from 'hooks/useTheme'
import { Box, Text } from 'vvs-uikit'

const Warning = () => {
  const { t } = useTranslation()
  const { theme, isDark } = useTheme()

  return (
    <Box maxWidth="468px" borderRadius="12px" background={isDark ? '#424B6E' : theme.colors.lightAqua} p="18px">
      <Text small>
        {t(
          'Upgrading your locking period is irreversible. By upgrading your locking period, the new period end date will be the full term of the selected locking period.',
        )}
      </Text>
    </Box>
  )
}

export default Warning
